import {Component, Input, OnInit} from '@angular/core';
import * as L from 'leaflet';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';

declare var System: any;

@Component({
  selector: 'tx-last-coordinate-display',
  templateUrl: './last-coordinate-display.component.html',
  styleUrls: ['./last-coordinate-display.component.css']
})
export class LastCoordinateDisplayComponent implements OnInit {
  _coordinate: any;
  running = true;
  _run: boolean;

  constructor(private _diagnosisNotification: DiagnosisWebSocketService) {

  }

  ngOnInit() {
    if (this._coordinate === undefined) {
      this.observeRestart();
      this.observeVehicle();
      this.subscribeCoordinateResponse();
    }
  }

  get run() {
    return this._run;
  }

  @Input()
  set run(run) {
    this._run = run;

    if (!this._run) {
      this.running = false;
    }
  }

  get coordinate() {
    return this._coordinate;
  }

  @Input()
  set coordinate(coordinate) {
    this._coordinate = coordinate;
  }

  observeRestart() {
    this._diagnosisNotification.restart$
      .subscribe(() => {
        this.running = true;
      });
  }

  observeVehicle() {
    this._diagnosisNotification.vehicle$
      .subscribe((vehicle) => {
        this.running = true;
      });
  }

  subscribeCoordinateResponse() {
    this._diagnosisNotification.response$
      .filter(data => data instanceof Array)
      .subscribe(coordinates => {
        this._coordinate = coordinates[0].position;
        this.running = false;
      });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/last-coordinate-display/last-coordinate-display.component.ts